import type { Media } from '../../types/FullProduct'

const MAX_IMAGES_LAST_ROW = 4
const IMAGES_PER_ROW = 2

const LAST_THREE_IMAGES_INDEX = 3
const LAST_FOUR_IMAGES_INDEX = 4
const LAST_IMAGE_INDEX = 1
const FULL_SIZE_VIEWWIDTH = 66

const HALF = 2
const ONE_THIRD = 3
const ONE_QUARTER = 4

const IMAGE_VIEWWIDTH_SIZES = {
	FULL: `${FULL_SIZE_VIEWWIDTH}vw`,
	HALF: `${FULL_SIZE_VIEWWIDTH / HALF}vw`,
	THIRD: `${Math.floor(FULL_SIZE_VIEWWIDTH / ONE_THIRD)}vw`,
	QUARTER: `${Math.floor(FULL_SIZE_VIEWWIDTH / ONE_QUARTER)}vw`,
}

interface GridInfo {
	hasFullImage: boolean
	hasThreeRow: boolean
	hasFourRow: boolean
}

interface GetImageGridStylesProps {
	gridInfo: GridInfo
	media: Media[]
	index: number
	styles: {
		readonly [key: string]: string
	}
}

interface GridStyles {
	viewWidth: string
	className: string
}

export const getImageGridInfo = (media: Media[]): GridInfo => {
	const hasCombinedRow = media.length > MAX_IMAGES_LAST_ROW
	const hasFullImage = !hasCombinedRow && media.length % IMAGES_PER_ROW === 1
	const hasThreeRow = hasCombinedRow && media.length % IMAGES_PER_ROW === 1
	const hasFourRow = hasCombinedRow && media.length % IMAGES_PER_ROW === 0

	return { hasFullImage, hasThreeRow, hasFourRow }
}

export const getImageGridStyles = ({
	gridInfo,
	media,
	index,
	styles,
}: GetImageGridStylesProps): GridStyles => {
	const { hasFullImage, hasThreeRow, hasFourRow } = gridInfo

	const isOnFullSize = hasFullImage && index === media.length - LAST_IMAGE_INDEX
	const isOnAThreeRow =
		hasThreeRow && index >= media.length - LAST_THREE_IMAGES_INDEX
	const isOnAFourRow =
		hasFourRow && index >= media.length - LAST_FOUR_IMAGES_INDEX

	if (isOnFullSize) {
		return {
			viewWidth: IMAGE_VIEWWIDTH_SIZES.FULL,
			className: styles.fullImage,
		}
	}
	if (isOnAThreeRow) {
		return {
			viewWidth: IMAGE_VIEWWIDTH_SIZES.THIRD,
			className: styles.threeRowImage,
		}
	}
	if (isOnAFourRow) {
		return {
			viewWidth: IMAGE_VIEWWIDTH_SIZES.QUARTER,
			className: styles.fourRowImage,
		}
	}
	return {
		viewWidth: IMAGE_VIEWWIDTH_SIZES.HALF,
		className: styles.twoRowImage,
	}
}
